module.exports = __webpack_public_path__ + "static/media/calendar.c3d6eca7.svg";